import jwtDecode from 'jwt-decode';

export const TOKEN_KEY = 'token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setToken = (token) => {
	if (token) {
		localStorage.setItem(TOKEN_KEY, token);
	} else {
		localStorage.removeItem(TOKEN_KEY);
	}
};

export const clearAuth = () => {
	localStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem('PublicUrlIds');
	localStorage.removeItem('adminSelectedAccountId');
};

export const parseToken = (token) => {
	if (!token || typeof token !== 'string') {
		return null;
	}

	try {
		const decoded = jwtDecode(token);
		if (decoded.exp && decoded.exp * 1000 < Date.now()) {
			return null;
		}
		return decoded;
	} catch {
		return null;
	}
};

export const getOrgInfoFromToken = (token) => {
	const decoded = parseToken(token);
	if (!decoded?.data) {
		return null;
	}

	const { email, orgDomain, roleId, orgId, orgName } = decoded.data;
	return {
		user: email || '',
		domain: orgDomain || '',
		roleId: roleId || '',
		orgId: orgId || '',
		orgName: orgName || '',
	};
};

export const isAuthenticated = (token) => Boolean(parseToken(token));
